var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "selectRadio w-100 shadow-2 bg-white radius-10 cursor-pointer mt-20 mob-my-10",
          class: { "p-20": _vm.title },
          on: {
            click: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.doClick()
            },
          },
        },
        [
          _c("input", {
            attrs: { type: "radio" },
            domProps: { checked: _vm.currentMode == _vm.mode, value: _vm.mode },
          }),
          _vm._v(" "),
          _c("label", { staticClass: "w-100" }, [
            _vm.title
              ? _c("div", {
                  staticClass: "w-100",
                  domProps: { innerHTML: _vm._s(_vm.title) },
                })
              : _c("div", { staticClass: "w-100" }, [_vm._t("title")], 2),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("CollapseTransition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen && _vm.$slots.default,
                expression: "isOpen && $slots.default",
              },
            ],
            staticClass: "p-20 mob-p-15 bg-grey5 radius-5 radius-top-0",
          },
          [_vm._t("default")],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }